<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <app-add-edit-modal (refresh)="onRefreshList(false)" triggerTitle="Lager anlegen"></app-add-edit-modal>
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
</app-table-header>
<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="stores-list-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="id" [nzSortFn]="true" nzWidth="75px">#ID</th>
      <th nzColumnKey="name" [nzSortFn]="true">Name</th>
      <th nzColumnKey="shortCode" [nzSortFn]="true">Kürzel</th>
      <th nzColumnKey="address" [nzSortFn]="true">Adresse</th>
      <th nzColumnKey="isMainStore" [nzSortFn]="true">Haupt-Lagerhaus</th>
      <th nzColumnKey="isBbmStore" [nzSortFn]="true" nzWidth="130px">BBM-Lager</th>
      <th nzColumnKey="isFlourStore" [nzSortFn]="true" nzWidth="130px">Flour-Lager</th>
      <th nzColumnKey="isActive" [nzSortFn]="true">Aktiv</th>
      <th nzColumnKey="actions" nzRight nzWidth="70px"></th>
    </tr>
  </thead>
  <tbody>
    @for (store of data.results; track store) {
      <tr>
        <td>{{store.id}}</td>
        <td>{{store.name}}</td>
        <td>{{store.shortCode}}</td>
        <td>{{store.address || '–'}}</td>
        <td nzAlign="center"><app-boolean-icon [state]="store.isMainStore"></app-boolean-icon></td>
        <td nzAlign="center" class="cell-nowrap"><app-boolean-icon [state]="store.isBbmStore"></app-boolean-icon></td>
        <td nzAlign="center" class="cell-nowrap"><app-boolean-icon [state]="store.isFlourStore"></app-boolean-icon></td>
        <td nzAlign="center"><app-boolean-icon [state]="store.isActive"></app-boolean-icon></td>
        <td nzRight>
          <div class="actions">
            <app-add-edit-modal (refresh)="onRefreshList(false)" #modal>
              <span trigger>
                <app-icon-button
                  icon="edit"
                  [ariaLabel]="'Lager bearbeiten: ' + store.name"
                  (pressed)="modal.showModal(store)"
                ></app-icon-button>
              </span>
            </app-add-edit-modal>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
